// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__2fryy","spin":"Spinner_spin__8ZlXw","container":"Spinner_container__WHWxI"};